module.exports = __webpack_public_path__ + "img/icon-star3-active.5f46cef0.png";